import { render, staticRenderFns } from "./_Players.vue?vue&type=template&id=725d950a&scoped=true&"
import script from "./_Players.vue?vue&type=script&lang=ts&"
export * from "./_Players.vue?vue&type=script&lang=ts&"
import style0 from "./_Players.vue?vue&type=style&index=0&id=725d950a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d950a",
  null
  
)

export default component.exports